import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    marginTop: 20,
  },

  dataSection: {
    marginTop: 7,
  },

  totalSumSection: {
    marginTop: 10,
    height: '58px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 7,
    borderTop: `1px solid ${colors.neutral200}`,
    borderBottom: `1px solid ${colors.neutral200}`,
  },

  boldText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '2px',
    color: colors.neutral900,
  },

  boldMediumText: {
    fontSize: 14,
    color: colors.neutral900,
  },
});
